<template>
  <div
    class="maintainence-banner"
    v-if="Object.keys(notification).length"
    v-bind:style="{ 'border-color': notification.color }"
  >
    <div class="banner-container">
      <div class="content-box">
        <div class="logo-box" v-bind:style="{ background: notification.color }">
          <img
            :src="getBlobUrl(notification.logo_location)"
            v-if="notification.logo_location"
            alt="notification-imgs"
          />
        </div>
        <div class="banner-content">
          <p
            class="banner-type"
            :class="[customWidth ? 'wd-600' : 'wd-500']"
            v-bind:style="{ color: notification.color }"
          >
            {{ notification.header }}
          </p>
          <p class="banner-time">{{ customNotificationDate() }}</p>
          <p class="banner-message" :class="[customWidth ? 'wd-600' : 'wd-500']">
            {{ notification.message }}
          </p>
        </div>
        <div class="pl-25 mt-24" v-if="afterLogin">
          <button class="btn side-btn emergo-blue-button" @click="setBannerStatus">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { bannerStatus } from '../../apis/systemNotifications';

export default {
  data() {
    return {
      timeZone: process.env.VUE_APP_CST_TIMEZONE,
      dateCSTFormat: 'dddd, MMMM DD, hh:mm A',
      UTCFormat: 'YYYY-MM-DD HH:mm:ss',
      customWidth: false
    };
  },
  props: ['notification', 'afterLogin'],
  methods: {
    customNotificationDate() {
      if (
        this.notification.start_date &&
        this.notification.end_date &&
        moment.utc(this.notification.start_date).format('DD/MM/YYYY') !==
          moment.utc(this.notification.end_date).format('DD/MM/YYYY')
      ) {
        this.customWidth = true;
        return `${moment
          .utc(this.notification.start_date)
          .utcOffset(this.timeZone)
          .format(this.dateCSTFormat)} CST To ${moment
          .utc(this.notification.end_date)
          .utcOffset(this.timeZone)
          .format(this.dateCSTFormat)} CST`;
      }
      if (
        this.notification.start_date &&
        this.notification.end_date &&
        moment.utc(this.notification.start_date).format('DD/MM/YYYY') ===
          moment.utc(this.notification.end_date).format('DD/MM/YYYY')
      ) {
        this.customWidth = false;
        return `${moment
          .utc(this.notification.start_date)
          .utcOffset(this.timeZone)
          .format(this.dateCSTFormat)} CST To ${moment
          .utc(this.notification.end_date)
          .utcOffset(this.timeZone)
          .format('hh:mm A')} CST`;
      }
      this.customWidth = false;
      return '';
    },
    getBlobUrl(filePath) {
      if (filePath && filePath.includes('blob:http')) {
        return filePath;
      }
      if (filePath) return `${process.env.VUE_APP_AZURE_BLOB_URL}${filePath}`;
      return null;
    },
    async setBannerStatus() {
      const formData = {
        user_id: JSON.parse(localStorage.getItem('userId')),
        banner_id: this.notification.id
      };
      const status = await bannerStatus(formData);
      this.$emit('userStatus', status);
    }
  },
  mounted() {
    this.customNotificationDate();
  }
};
</script>
<style lang="scss" scoped>
.maintainence-banner {
  background: $deep-white;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  border-top: 10px;
  border-style: solid;
  border-width: 10px 0 0 0;
  margin: auto;
  display: inline-block;
  .logo-box {
    border-radius: 4px;
    transform: rotate(45deg);
    min-width: 50px;
    height: 50px;
    max-width: 50px;
    display: flex;
    justify-content: center;
    margin-top: 15px;
    img {
      transform: rotate(-45deg);
      width: 30px;
      height: 30px;
      display: block;
      margin: auto;
    }
  }
}
.banner-container {
  margin: 20px auto;
}
.mt-24 {
  margin-top: 24px;
}
.side-btn {
  font-size: $font-18;
  padding-right: 30px;
  padding-left: 30px;
  line-height: 21px;
}
.content-box {
  display: flex;
  padding: 25px;
  justify-content: center;
}
.banner-content {
  text-align: left;
  padding-left: 22px;
  padding-right: 12px;
  max-height: 128px;
  overflow-y: auto;
  scrollbar-width: thin;
  .banner-type {
    font-size: $font-16;
    font-weight: $font-weight-medium;
    margin: 0 0 5px 0;
    font-family: Roboto;
  }
  .banner-time {
    font-size: $font-22;
    margin: 0 0 5px 0;
    font-family: Roboto;
    line-height: 22px;
  }
  .banner-message {
    font-size: $font-16;
    margin: 0;
    color: #4f4f4f;
    font-family: Roboto;
    font-style: normal;
    font-weight: $font-weight-small;
  }
  .wd-500 {
    width: 500px;
  }
  .wd-600 {
    width: 600px;
  }
}
.banner-message:first-letter,
.banner-type:first-letter {
  text-transform: capitalize;
}
@media screen and (max-width: 767px) {
  .banner-container {
    padding: 20px;
  }
  .content-box {
    padding: 0;
  }
  .banner-content {
    .wd-500 {
      width: auto;
    }
  }
}
@media screen and (max-width: 1200px) {
  .banner-content {
    .wd-600 {
      width: auto;
    }
  }
}
</style>
